import * as React from 'react';
import { listOpenStateHandlersContext } from './context';
export var OpenStateProvider = function (props) {
    var children = props.children;
    var openHandlers = React.useState(false);
    return (React.createElement(listOpenStateHandlersContext.Provider, { value: openHandlers }, children));
};
